import { render, staticRenderFns } from "./AnimationBackground.vue?vue&type=template&id=5a05e326"
import script from "./AnimationBackground.vue?vue&type=script&lang=js"
export * from "./AnimationBackground.vue?vue&type=script&lang=js"
import style0 from "./AnimationBackground.vue?vue&type=style&index=0&id=5a05e326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports